import { MULTI_SHOP_ENABLED } from '@core/config/shops';
import {
  isGlobalProductId,
  makeGlobalProductId,
  parseGlobalProductId,
} from '@core/utils/globalIds';

/** Category tab ids: same composite format as products (`shopId::localId`). */
export function scopeCategoryId(shopId: string, localCategoryId: string): string {
  return makeGlobalProductId(shopId, localCategoryId);
}

export function parseCategorySelection(
  compositeOrLocalId: string | null,
  fallbackShopId: string
): { shopId: string; localCategoryId: string } | null {
  if (!compositeOrLocalId) return null;
  if (MULTI_SHOP_ENABLED && isGlobalProductId(compositeOrLocalId)) {
    const p = parseGlobalProductId(compositeOrLocalId);
    if (p) return { shopId: p.shopId, localCategoryId: p.localProductId };
  }
  return {
    shopId: fallbackShopId,
    localCategoryId: compositeOrLocalId,
  };
}
